/**
 * Shopify Performance Architecture - Robust Universal Auto FAQ Accordion & Schema (v3.0)
 * Reagiert tolerant auf fehlende <p>-Tags, unsaubere HTML-Strukturen und Bootstrap-Panels.
 */
(() => {
  const initAutoFaq = () => {
    // ==========================================
    // PATTERN A: Flache Struktur (#FAQ Anker + H3 + beliebiger Content)
    // ==========================================
    const flatFaqHeadings = document.querySelectorAll('#FAQ, [id="FAQ"]');
    flatFaqHeadings.forEach((faqHeading) => {
      if (faqHeading.dataset.faqInitialized) return;
      faqHeading.dataset.faqInitialized = 'true';

      const faqSchemaItems = [];
      const container = document.createElement('div');
      container.className = 'auto-faq-accordion__wrapper';

      let currentElement = faqHeading.nextElementSibling;
      const elementsToRemove = [];

      while (currentElement) {
        // Stoppe, wenn die nächste Hauptüberschrift (H1 oder H2) erreicht wird
        if (['H1', 'H2'].includes(currentElement.tagName)) break;

        if (currentElement.tagName === 'H3') {
          const h3 = currentElement;
          const questionText = h3.textContent.trim();
          const questionHtml = h3.innerHTML;
          
          // Sammle ALLE nachfolgenden Elemente bis zum nächsten H1, H2 oder H3
          const answerNodes = [];
          let answerSibling = h3.nextSibling; // Nimmt auch reine Text-Nodes auf!

          while (answerSibling) {
            // Stoppe bei der nächsten Überschrift
            if (answerSibling.nodeType === Node.ELEMENT_NODE && ['H1', 'H2', 'H3'].includes(answerSibling.tagName)) {
              break;
            }

            const siblingToProcess = answerSibling;
            answerSibling = answerSibling.nextSibling; // Vorab zum nächsten Pointer springen

            // Ignoriere leere Text-Nodes (Zeilenumbrüche)
            if (siblingToProcess.nodeType === Node.TEXT_NODE && !siblingToProcess.textContent.trim()) {
              continue;
            }

            answerNodes.push(siblingToProcess);
          }

          if (answerNodes.length > 0) {
            // erstelle einen temporären Container für den gesammelten Antwort-Inhalt
            const answerWrapper = document.createElement('div');
            
            answerNodes.forEach(node => {
              if (node.nodeType === Node.TEXT_NODE) {
                // Hüllt losen Text automatisch in ein sauberes <p>-Tag ein
                const p = document.createElement('p');
                p.textContent = node.textContent.trim();
                answerWrapper.appendChild(p);
              } else {
                answerWrapper.appendChild(node.cloneNode(true));
              }
              elementsToRemove.push(node);
            });

            const answerHtml = answerWrapper.innerHTML.trim();
            const answerPlainText = answerWrapper.textContent.trim();

            // Erstelle das Akkordeon
            const details = createAccordionItem(questionHtml, answerHtml);
            container.appendChild(details);

            // Schema-Eintrag speichern
            faqSchemaItems.push({
              "@type": "Question",
              "name": questionText,
              "acceptedAnswer": {
                "@type": "Answer",
                "text": answerPlainText
              }
            });

            elementsToRemove.push(h3);
            currentElement = answerSibling;
            continue;
          }
        }
        currentElement = currentElement.nextElementSibling;
      }

      if (faqSchemaItems.length > 0) {
        // Alte Elemente aus dem DOM entfernen & Akkordeon einfügen
        elementsToRemove.forEach(el => {
          if (el && el.parentNode) el.parentNode.removeChild(el);
        });
        faqHeading.after(container);
        injectJsonLd(faqSchemaItems);
      }
    });

    // ==========================================
    // PATTERN B: Bootstrap Panel-Struktur (.panel-group / #accordion / .mc-faq)
    // ==========================================
    const panelFaqContainers = document.querySelectorAll('#accordion, .panel-group, .mc-faq');
    panelFaqContainers.forEach((panelContainer) => {
      if (panelContainer.dataset.faqInitialized) return;
      panelContainer.dataset.faqInitialized = 'true';

      const panels = panelContainer.querySelectorAll('.panel');
      if (!panels.length) return;

      const faqSchemaItems = [];
      const container = document.createElement('div');
      container.className = 'auto-faq-accordion__wrapper';

      const faqHeader = panelContainer.querySelector('.faqHeader');
      if (faqHeader) {
        container.appendChild(faqHeader.cloneNode(true));
      }

      panels.forEach((panel) => {
        const titleEl = panel.querySelector('.panel-title a, .panel-heading');
        const bodyEl = panel.querySelector('.panel-body');

        if (titleEl && bodyEl) {
          const questionText = titleEl.textContent.trim();
          const answerHtml = bodyEl.innerHTML.trim();

          const details = createAccordionItem(titleEl.innerHTML, answerHtml);
          container.appendChild(details);

          faqSchemaItems.push({
            "@type": "Question",
            "name": questionText,
            "acceptedAnswer": {
              "@type": "Answer",
              "text": bodyEl.textContent.trim()
            }
          });
        }
      });

      if (faqSchemaItems.length > 0) {
        panelContainer.parentNode.replaceChild(container, panelContainer);
        injectJsonLd(faqSchemaItems);
      }
    });
  };

  const createAccordionItem = (titleHtml, contentHtml) => {
    const details = document.createElement('details');
    details.className = 'auto-faq-accordion__item';

    const summary = document.createElement('summary');
    summary.className = 'auto-faq-accordion__title t3';
    summary.innerHTML = `<span>${titleHtml}</span><span class="auto-faq-accordion__icon" aria-hidden="true">+</span>`;

    const content = document.createElement('div');
    content.className = 'auto-faq-accordion__content';
    content.innerHTML = contentHtml;

    details.appendChild(summary);
    details.appendChild(content);
    return details;
  };

  const injectJsonLd = (items) => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": items
    });
    document.head.appendChild(script);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAutoFaq);
  } else {
    initAutoFaq();
  }
})();